import React, { useState } from "react";
import { Dialog, DialogContent, TextField, Box, Typography } from "@mui/material";
import { updateUserEmail as updateUserEmailCallable } from "../../config/firebase";
import ModalDialogTitle from "../common/ModalDialogTitle";
import ModalActions from "../common/ModalActions";

const EmailUpdateDialog = ({ open, onClose, instructor, onSuccess }) => {
  const [email, setEmail] = useState(instructor?.email || "");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setEmail(instructor?.email || "");
  }, [instructor]);

  const handleSubmit = async () => {
    if (!instructor || !instructor.id) return;
    setLoading(true);
    try {
      const res = await updateUserEmailCallable(instructor.id, email);
      if (res && res.success) {
        if (onSuccess) onSuccess();
        onClose();
      } else {
        alert(res.message || "Failed to update email");
      }
    } catch (err) {
      console.error("Error calling updateUserEmail:", err);
      alert(err.message || "Error updating email");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <ModalDialogTitle onClose={onClose}>
        Update Instructor Email
      </ModalDialogTitle>
      <DialogContent>
        <Box mt={1}>
          <Typography variant="body2">
            Updating the email will update both Firebase Authentication and the
            Firestore users document. This action requires administrator
            privileges.
          </Typography>
        </Box>
        <Box mt={2}>
          <TextField
            label="New Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
      </DialogContent>
      <ModalActions
        onSave={handleSubmit}
        saving={loading}
        saveLabel="Update Email"
      />
    </Dialog>
  );
};

export default EmailUpdateDialog;
